import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, watch } from "vue";
import {} from "@/api/notifications";
import { snakeCaseToTitleCase } from "@/utils/strings";
import NotificationsChannelSettings from "./NotificationsChannelSettings.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsCategorySettings',
    props: {
        preferences: null,
        supportedChannels: null,
        category: null
    },
    emits: ["onCategoryEnabledChange", "onChannelChange"],
    setup(__props, { emit }) {
        const props = __props;
        const categoryDescriptionMap = {
            message: `
        You will receive these notifications only when your Galaxy administrators send you a message.
        Please note that for certain critical or urgent messages, you will receive notifications even if you have disabled this channel.
    `,
            new_shared_item: "You will receive these notifications when someone shares an item with you i.e. a history, workflow, visualization, etc.",
        };
        const isCategoryEnabled = ref(props.preferences[props.category].enabled);
        const checkBoxTitle = computed(() => (isCategoryEnabled.value ? "Disable notifications" : "Enable notifications"));
        const categoryDescription = computed(() => categoryDescriptionMap[props.category]);
        watch(() => isCategoryEnabled.value, (newValue) => {
            emit("onCategoryEnabledChange", props.category, newValue);
        });
        function onChannelChange(category, channel, value) {
            emit("onChannelChange", category, channel, value);
        }
        return { __sfc: true, categoryDescriptionMap, props, emit, isCategoryEnabled, checkBoxTitle, categoryDescription, onChannelChange, snakeCaseToTitleCase, NotificationsChannelSettings };
    }
});
